import { render, staticRenderFns } from "./ReadTicket.vue?vue&type=template&id=58dde568&scoped=true&"
import script from "./ReadTicket.vue?vue&type=script&lang=js&"
export * from "./ReadTicket.vue?vue&type=script&lang=js&"
import style0 from "./ReadTicket.vue?vue&type=style&index=0&id=58dde568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dde568",
  null
  
)

export default component.exports